import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { failedResponses } from '../errors/responses';

const c = initContract();

export const Address = z.object({
  id: z.string(),
  name: z.string(),
  line1: z.string(),
  line2: z.string().optional(),
  city: z.string(),
  state: z.string().optional(),
  country: z.string().optional(),
  postcode: z.string()
});

export type Address = z.infer<typeof Address>;

export const AddressResponse = Address.merge(
  z.object({
    id: z.string()
  })
);

export const AddressDto = z.object({
  id: z.string(),
  name: z.string(),
  line1: z.string(),
  line2: z.string().optional().nullable(),
  city: z.string(),
  state: z.string().optional().nullable(),
  country: z.string().optional().nullable(),
  postcode: z.string(),
  companyId: z.string().optional().nullable(),
  partnerId: z.string().optional().nullable()
});

export type AddressDto = z.infer<typeof AddressDto>;

export const AddressRequest = AddressDto.omit({ id: true }).extend({
  saveToAddressBook: z.boolean().optional()
});
export type AddressRequest = z.infer<typeof AddressRequest>;

export default c.router({
  // --- Customer Addresses ---
  getCustomerAddresses: {
    method: 'GET',
    path: '/msp/:mspId/customers/:customerId/addresses',
    responses: {
      200: z.array(AddressDto),
      ...failedResponses
    }
  },
  getCustomerAddress: {
    method: 'GET',
    path: '/msp/:mspId/customers/:customerId/addresses/:id',
    responses: {
      200: AddressDto,
      ...failedResponses
    }
  },
  createCustomerAddress: {
    method: 'POST',
    path: '/msp/:mspId/customers/:customerId/addresses',
    responses: {
      200: AddressDto,
      ...failedResponses
    },
    body: AddressRequest
  },
  updateCustomerAddress: {
    method: 'PUT',
    path: '/msp/:mspId/customers/:customerId/addresses/:id',
    responses: {
      200: AddressDto,
      ...failedResponses
    },
    body: AddressRequest
  },
  deleteCustomerAddress: {
    method: 'DELETE',
    path: '/msp/:mspId/customers/:customerId/addresses/:id',
    responses: {
      204: c.type<void>(),
      200: c.type<void>(),
      ...failedResponses
    },
    body: c.type<unknown>()
  },
  
  // --- Partner Addresses ---
  getPartnerAddresses: {
    method: 'GET',
    path: '/msp/:mspId/addresses',
    responses: {
      200: z.array(AddressDto),
      ...failedResponses
    }
  },
  getPartnerAddress: {
    method: 'GET',
    path: '/msp/:mspId/addresses/:id',
    responses: {
      200: AddressDto,
      ...failedResponses
    }
  },
  createPartnerAddress: {
    method: 'POST',
    path: '/msp/:mspId/addresses',
    responses: {
      200: AddressDto,
      ...failedResponses
    },
    body: AddressRequest
  },
  updatePartnerAddress: {
    method: 'PUT',
    path: '/msp/:mspId/addresses/:id',
    responses: {
      200: AddressDto,
      ...failedResponses
    },
    body: AddressRequest
  },
  deletePartnerAddress: {
    method: 'DELETE',
    path: '/msp/:mspId/addresses/:id',
    responses: {
      204: c.type<void>(),
      200: c.type<void>(),
      ...failedResponses
    },
    body: c.type<unknown>()
  }
});
